// Moment format
export const MOMENT_DATETIME_SECONDS_FORMAT = 'MMM. D, YYYY, h:mm:ssa' // Jan. 1, 2000, 3:15:10pm
export const MOMENT_DATETIME_FORMAT = 'MMM D, YYYY, h:mma' // Jan 1, 2000, 3:15pm
export const MOMENT_DATE_FORMAT = 'MMM D, YYYY' // Jan 1, 2000
export const MOMENT_SHORTDATE_FORMAT = 'MMM D' // Jan 1
export const MOMENT_TIME_FORMAT = 'h:mma' // 3:15pm
export const MOMENT_TIMESECONDS_FORMAT = 'h:mm:ssa' // 3:15:39pm

// VISITS
export const VISITS_PAGINATION_LIMIT = 20

// Form
export const PASSWORD_MIN_LENGTH = 8 // characters

// Transcription
export const TRANSCRIPTION_MIN_LENGTH = 100 // characters

// Subscriptin
export const TRIAL_PERIOD = 14 // days

// Transcriber
export type Language =
    | 'en-US' // English
    | 'es-US' // Spanish
    | 'fr-CA' // French
    | 'zh-CN' // Chinese
    | 'hi-IN' // Hindi
    | 'ta-IN' // Tamil
    | 'pa-IN' // Punjabi
    | 'bn-IN' // Bengali
    | 'ur-IN' // Urdu
    | 'ar-SY' // Arabic
    | 'uk-UA' // Ukrainian
    | 'ru-RU' // Russian
    | 'hy-AM' // Armenian
    | 'fil-PH' // Filipino
    | 'ja-JP' // Japanese
    | 'ko-KR' // Korean
    | 'it-IT' // Italian
    | 'el-GR' // Greek
    | 'fa-IR' // Persian
    | 'pl-PL' // Polish
    | 'pt-PT' // Portuguese

export const LANGUAGES: Language[] = [
    'en-US',
    'es-US',
    'fr-CA',
    'zh-CN',
    'hi-IN',
    'ta-IN',
    'pa-IN',
    'bn-IN',
    'ur-IN',
    'ar-SY',
    'uk-UA',
    'ru-RU',
    'hy-AM',
    'fil-PH',
    'ja-JP',
    'ko-KR',
    'it-IT',
    'el-GR',
    'fa-IR',
    'pl-PL',
    'pt-PT'
]
export const DEFAULT_LANGUAGE = 'en-US'
export const LANGUAGES_LABEL: Record<Language, string> = {
    'en-US': 'English',
    'es-US': 'Spanish',
    'fr-CA': 'French',
    'zh-CN': 'Chinese',
    'hi-IN': 'Hindi',
    'ta-IN': 'Tamil',
    'pa-IN': 'Punjabi',
    'bn-IN': 'Bengali',
    'ur-IN': 'Urdu',
    'ar-SY': 'Arabic',
    'uk-UA': 'Ukrainian',
    'ru-RU': 'Russian',
    'hy-AM': 'Armenian',
    'fil-PH': 'Filipino',
    'ja-JP': 'Japanese',
    'ko-KR': 'Korean',
    'it-IT': 'Italian',
    'el-GR': 'Greek',
    'fa-IR': 'Persian',
    'pl-PL': 'Polish',
    'pt-PT': 'Portuguese'
}

export const JOIN_FULENT_EMAIL = (inviteLink: string) => {
    const subject = 'Join avaros.ai'
    const body = `Hi there,

I've been using avaros.ai, and I thought you'd love it too! It’s a great platform for managing health and wellness, helping you stay on top of your health goals effortlessly.

Sign up using my referral link to get started: ${inviteLink}

Looking forward to seeing you on avaros.ai!

Best,
[Your Name]`

    return [subject, body]
}

export const PAUSE_RECORDING_TIME_LIMIT = parseInt(process?.env?.REACT_APP_PAUSE_RECORDING_INACTIVITY_TIME_LIMIT || '120') // In seconds

export const TIMEOVER_CONDITION = (time: number, passedTime = 0): boolean => {
    const startTime = parseInt(process?.env?.REACT_APP_RECORDER_ACTIVITY_CHECK_STARTTIME || '3600') // Default to 60 mins
    const frequency = parseInt(process?.env?.REACT_APP_RECORDER_ACTIVITY_CHECK_FREQUENCY || '1800') // Default to 30 mins

    if (time - passedTime === startTime || (time - passedTime > startTime && (time - passedTime) % frequency === 0)) return true
    return false
}

export const DICTATION_COMMANDS = [
    { command: 'next/new line', result: 'Moves the cursor to a new line' },
    { command: 'new paragraph', result: 'Moves the cursor down two lines, like a new paragraph section' },
    { command: 'full stop', result: 'Add a period' }
]

export const SNIPPET_START_CHAR = '/'
